export abstract class Marketplace {
    /**
     * Method for the platform to override to have the obfuscated marketplace id retrieval of the marketplace
     * based on the platform, and return obfuscated marketplace id of the marketplace
     * @return {undefined | string} undefined
     */
    public getObfuscatedMarketplaceId(): undefined | string {
        return undefined;
    }
    /**
     * Method for the platform to override to have the default locale retrieval of the marketplace based on
     * the platform, and return default locale of the marketplace
     *
     * @return {undefined | string} undefined
     */
    public getDefaultLocale(): undefined | string {
        return Intl.DateTimeFormat().resolvedOptions().locale;
    }
    /**
     * Method for the platform to override to have the default currency retrieval of the marketplace based on
     * the platform, and return default currency of the marketplace
     *
     * @return {undefined | string} undefined
     */
    public getDefaultCurrency(): undefined | string {
        return undefined;
    }
}
